import { useState, useCallback } from "react";
import { toast } from "sonner";

/**
 * Shared geolocation helper.
 *
 * Returns a `getCurrentPosition()` that resolves to {latitude, longitude}
 * using the browser's GPS. Surfaces friendly Norwegian errors when the user
 * denies / no permission exists / position unavailable.
 */
export function useGeolocation() {
  const [busy, setBusy] = useState(false);

  const getCurrentPosition = useCallback(() => {
    return new Promise((resolve, reject) => {
      if (!("geolocation" in navigator)) {
        toast.error("Nettleseren din støtter ikke posisjonsbestemmelse");
        reject(new Error("geolocation_unsupported"));
        return;
      }
      setBusy(true);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setBusy(false);
          resolve({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          });
        },
        (err) => {
          setBusy(false);
          if (err.code === 1)
            toast.error("Du må gi tilgang til posisjonen din for å bruke denne funksjonen");
          else toast.error("Klarte ikke hente posisjon — prøv postnummer i stedet");
          reject(err);
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 },
      );
    });
  }, []);

  return { busy, getCurrentPosition };
}
